module.exports = __webpack_public_path__ + "img/trip_sendai06.7d260695.jpg";